import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

const state = {
  shippingServices: [],
  storeShippingConfigs: [],
  availableShippingServices: []
}

export default {
  state,
  getters,
  mutations,
  actions
}
